import React from "react";

export function TiktokColored({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3583 6.25H38.6406C41.4625 6.25 43.75 8.5375 43.75 11.3583V38.6406C43.75 41.4625 41.4625 43.75 38.6417 43.75H11.3583C8.5375 43.75 6.25 41.4625 6.25 38.6417V11.3583C6.25 8.5375 8.5375 6.25 11.3583 6.25Z"
        fill="#212121"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.4248 21.4657C32.0665 22.6386 34.0779 23.3282 36.2498 23.3282V19.15C35.8383 19.15 35.429 19.1073 35.0269 19.0219V22.3104C32.855 22.3104 30.8446 21.6198 29.2019 20.4479V28.9729C29.2019 33.2375 25.7425 36.6948 21.4758 36.6948C19.8842 36.6948 18.404 36.2136 17.1748 35.3886C18.5779 36.8219 20.5342 37.7115 22.6988 37.7115C26.9654 37.7115 30.4248 34.2542 30.4248 29.9896V21.4657ZM31.9342 17.2511C31.0956 16.3354 30.5446 15.1511 30.4248 13.8417V13.3042H29.2654C29.5571 14.9677 30.5529 16.3896 31.9342 17.2511ZM19.8738 32.1167C19.405 31.5021 19.1519 30.7511 19.1529 29.9782C19.1529 28.0271 20.7352 26.4459 22.6873 26.4459C23.0508 26.4459 23.4123 26.5011 23.7592 26.6115V22.3407C23.354 22.2854 22.9456 22.2615 22.5363 22.2698V25.5938C22.1894 25.4834 21.8279 25.4282 21.4633 25.4282C19.5113 25.4282 17.929 27.0094 17.929 28.9604C17.93 30.3407 18.7206 31.5354 19.8738 32.1167Z"
        fill="#EC407A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.2022 20.4479C30.8438 21.6209 32.8553 22.3104 35.0272 22.3104V19.0219C33.8147 18.7636 32.7418 18.1302 31.9345 17.25C30.5532 16.3886 29.5584 14.9677 29.2668 13.3042H26.222V29.9896C26.2147 31.9344 24.6355 33.5094 22.6876 33.5094C21.5397 33.5094 20.5199 32.9625 19.8741 32.1157C18.7209 31.5344 17.9303 30.3396 17.9303 28.9604C17.9303 27.0094 19.5126 25.4282 21.4647 25.4282C21.8386 25.4282 22.1991 25.4865 22.5376 25.5938V22.2709C18.3459 22.3573 14.9751 25.7802 14.9751 29.9907C14.9751 32.0927 15.8147 33.9979 17.1772 35.3896C18.4063 36.2146 19.8866 36.6959 21.4782 36.6959C25.7449 36.6959 29.2043 33.2386 29.2043 28.974L29.2022 20.4479Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.0271 19.0228V18.1333C33.9333 18.1353 32.8625 17.8291 31.9344 17.2499C32.7552 18.1489 33.8365 18.7687 35.0271 19.0228ZM29.2656 13.3041C29.2375 13.1447 29.2167 12.9853 29.2021 12.8239V12.2864H24.9979V28.9728C24.9917 30.9176 23.4115 32.4926 21.4635 32.4926C20.8917 32.4926 20.3521 32.3572 19.874 32.1155C20.5198 32.9624 21.5396 33.5093 22.6875 33.5093C24.6354 33.5093 26.2146 31.9343 26.2219 29.9895V13.3041H29.2656ZM22.5365 22.2708V21.3239C22.1854 21.276 21.8313 21.252 21.476 21.252C17.2083 21.252 13.75 24.7093 13.75 28.9739C13.75 31.6478 15.1094 34.0041 17.175 35.3895C15.8125 33.9978 14.9729 32.0926 14.9729 29.9905C14.9729 25.7801 18.3448 22.3572 22.5365 22.2708Z"
        fill="#81D4FA"
      />
    </svg>
  );
}
